<template>
  <dialog-base
    v-bind="{ ...$props, ...$attrs }"
    :key="renderKey"
    :header="$t('global.phrases.cloneSchedule')"
    :scrollable="true"
    max-width="450px"
    width="450px"
    has-dialog-actions
    :loading-message="`${$t('dock.forms.dockForm.messages.cloningSchedule')}...`"
    @close="close"
    @keydown.enter="emitCopySchedule"
    @submit="emitCopySchedule">
    <template v-slot:activator="props" v-if="!externalActivator">
      <slot v-if="$slots.activator" name="activator" v-bind="props"></slot>
      <v-btn
        v-else
        density="compact"
        v-bind="props"
        variant="plain"
        size="small"
        prepend-icon="mdi-content-copy"
        class="bg-white text-left justify-start my-0">
        {{ $t('dock.forms.dockForm.buttons.anotherDock') }}...
      </v-btn>
    </template>
    <template v-slot:body>
      <form-base hide-required-legend>
        <template #form>
          <v-form ref="form">
            <h4 class="text-black">
              {{ $t('dock.forms.dockForm.labels.dockScheduleToCloneFrom') }}:
            </h4>
            <dock-select
              data-testid="clone-dock-select"
              :multi-select="false"
              :display-checkboxes="false"
              :clearable="false"
              :prepend-icon="null"
              v-model="selectedDock"
              :docks="docks"
              :placeholder="$t('dock.forms.dockForm.placeholders.selectDock')"></dock-select>
          </v-form>
        </template>
      </form-base>
    </template>
    <template #dialog-actions>
      <action-group
        @cancel="close"
        confirm-icon="content-copy"
        :confirm-label="$t('global.phrases.cloneSchedule')"
        @confirm="emitCopySchedule"></action-group>
    </template>
  </dialog-base>
</template>

<script>
import dialogMixin from '@satellite/components/mixins/dialogMixin';

/**
 * Button/Dialog for edit create/edit dock form
 * @displayName Edit Dock Dialog
 */
export default {
  name: 'CloneDockScheduleDialog',
  mixins: [dialogMixin],
  props: {
    docks: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      selectedDock: {}
    };
  },
  methods: {
    emitCopySchedule() {
      this.$emit('copy-schedule', this.selectedDock.schedule);
      this.selectedDock = {};
      this.close();
    }
  }
};
</script>
